<template class="tech">
  <v-row>
    <v-col cols="12">
      <v-form class="ma-6 pa-0">
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dates"
                  label="Дата оплаты"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dates"
                range
                locale="ru-RU"
                :first-day-of-week="1"
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu = false">
                  Отмена
                </v-btn>
                <v-btn text color="primary" @click="$refs.menu.save(dates)">
                  Сохранить
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col>
            <v-autocomplete
              v-model="objSelect"
              :items="obj"
              item-text="NAME"
              item-value="ID"
              label="Объект"
              outlined
            ></v-autocomplete>
          </v-col>
          <v-col>
            <v-autocomplete
              v-model="objWorkSelect"
              :items="objWorks"
              label="Вид работ"
              required
              multiple
              outlined
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-btn
          text
          color="success"
          class="mr-4"
          @click="getReport"
          :disabled="loading"
        >
          Сформировать
        </v-btn>
        <v-btn
          text
          color="orange"
          class="mr-4"
          @click="exportXls"
          :disabled="loading"
        >
          Выгрузить XLS
        </v-btn>
      </v-form>
    </v-col>
    <v-col>
      <template>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr class="gray">
                <th
                  rowspan="2"
                  class="text-center orange"
                  style="min-width: 110px"
                >
                  Дата
                </th>
                <th
                  rowspan="2"
                  class="text-center orange"
                  style="min-width: 160px"
                >
                  Объект
                </th>
                <th
                  rowspan="2"
                  class="text-center grey"
                  style="min-width: 180px"
                >
                  Вид работ
                </th>
                <th colspan="5" class="text-center light-blue">
                  Использованный материал в работу
                </th>
                <th colspan="6" class="text-center light-green">
                  Использованная техника под данный вид работ
                </th>
                <th colspan="4" class="text-center yellow">
                  Работа рабочих задействованных
                </th>
              </tr>
              <tr class="gray">
                <th class="text-center light-blue">Единица измерения</th>
                <th class="text-center light-blue">Вид материала</th>
                <th class="text-center light-blue">План</th>
                <th class="text-center light-blue">Факт</th>
                <th class="text-center light-blue">Разница</th>
                <th class="text-center light-green">Единица измерения</th>
                <th class="text-center light-green">Вид техники</th>
                <th class="text-center light-green">Что делала техника</th>
                <th class="text-center light-green">План</th>
                <th class="text-center light-green">Факт</th>
                <th class="text-center light-green">Разница</th>
                <th class="text-center yellow">Единица измерения</th>
                <th class="text-center yellow">План</th>
                <th class="text-center yellow">Факт</th>
                <th class="text-center yellow">Разница</th>
              </tr>
            </thead>
            <template v-if="loading === true">
              <v-progress-linear
                :active="loading"
                :indeterminate="loading"
                absolute
                top
                color="light-green darken-4"
                height="10"
              ></v-progress-linear>
            </template>
            <tbody>
              <template v-for="item in reportData">
                <tr :key="item.id" class="border-bottom">
                  <td class="orange">{{ item.date }}</td>
                  <td class="orange">{{ item.obj }}</td>
                  <td class="grey">{{ item.objWork }}</td>
                  <td class="light-blue">{{ item.materialUnit }}</td>
                  <td class="light-blue">{{ item.material }}</td>
                  <td class="light-blue">{{ item.materialPlan }}</td>
                  <td class="light-blue">{{ item.materialQuantity }}</td>
                  <td class="light-blue">{{ item.materialDiff }}</td>
                  <td class="light-green">{{ item.techUnit }}</td>
                  <td class="light-green">{{ item.tech }}</td>
                  <td class="light-green">{{ item.techText }}</td>
                  <td class="light-green">{{ item.techPlan }}</td>
                  <td class="light-green">{{ item.techQuantity }}</td>
                  <td class="light-green">{{ item.techDiff }}</td>
                  <td class="yellow">{{ item.workersUnit }}</td>
                  <td class="yellow">{{ item.workersPlan }}</td>
                  <td class="yellow">{{ item.workersQuantity }}</td>
                  <td class="yellow">{{ item.workersDiff }}</td>
                </tr>
              </template>
            </tbody>
          </template>
        </v-simple-table>
      </template>
    </v-col>
    <v-col>
      <template>
        <h3>ИТОГО:</h3>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th
                  rowspan="2"
                  class="text-center orange"
                  style="min-width: 110px"
                ></th>
                <th
                  rowspan="2"
                  class="text-center orange"
                  style="min-width: 160px"
                >
                  Объект
                </th>
                <th
                  rowspan="2"
                  class="text-center grey"
                  style="min-width: 180px"
                >
                  Вид работ
                </th>
                <th colspan="5" class="text-center light-blue">
                  Использованный материал в работу
                </th>
                <th colspan="6" class="text-center light-green">
                  Использованная техника под данный вид работ
                </th>
                <th colspan="4" class="text-center yellow">
                  Работа рабочих задействованных
                </th>
              </tr>
              <tr>
                <th class="text-center light-blue">Единица измерения</th>
                <th class="text-center light-blue">Вид материала</th>
                <th class="text-center light-blue">План</th>
                <th class="text-center light-blue">Факт</th>
                <th class="text-center light-blue">Разница</th>
                <th class="text-center light-green">Единица измерения</th>
                <th class="text-center light-green">Вид техники</th>
                <th class="text-center light-green">Что делала техника</th>
                <th class="text-center light-green">План</th>
                <th class="text-center light-green">Факт</th>
                <th class="text-center light-green">Разница</th>
                <th class="text-center yellow">Единица измерения</th>
                <th class="text-center yellow">План</th>
                <th class="text-center yellow">Факт</th>
                <th class="text-center yellow">Разница</th>
              </tr>
            </thead>
            <template v-if="loading === true">
              <v-progress-linear
                :active="loading"
                :indeterminate="loading"
                absolute
                top
                color="light-green darken-4"
                height="10"
              ></v-progress-linear>
            </template>
            <tbody>
              <template v-for="item in totalReportData">
                <tr :key="item.id" class="border-bottom">
                  <td class="orange">{{ item.date }}</td>
                  <td class="orange">{{ item.obj }}</td>
                  <td class="grey">{{ item.objWork }}</td>
                  <td class="light-blue">{{ item.materialUnit }}</td>
                  <td class="light-blue">{{ item.material }}</td>
                  <td class="light-blue">{{ item.materialPlan }}</td>
                  <td class="light-blue">{{ item.materialQuantity }}</td>
                  <td class="light-blue">{{ item.materialDiff }}</td>
                  <td class="light-green">{{ item.techUnit }}</td>
                  <td class="light-green">{{ item.tech }}</td>
                  <td class="light-green">{{ item.techText }}</td>
                  <td class="light-green">{{ item.techPlan }}</td>
                  <td class="light-green">{{ item.techQuantity }}</td>
                  <td class="light-green">{{ item.techDiff }}</td>
                  <td class="yellow">{{ item.workersUnit }}</td>
                  <td class="yellow">{{ item.workersPlan }}</td>
                  <td class="yellow">{{ item.workersQuantity }}</td>
                  <td class="yellow">{{ item.workersDiff }}</td>
                </tr>
              </template>
            </tbody>
          </template>
        </v-simple-table>
      </template>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";
import exeljs from "exceljs";
import fileWrite from "file-saver";

export default {
  name: "report-table",
  data() {
    return {
      loading: false,
      menu: false,
      units: [
        "шт",
        "тн",
        "кг",
        "л",
        "м.п.",
        "м2",
        "м3",
        "ч/ч",
        "маш/час",
        "смена",
        "сутки",
      ],
      obj: [],
      objSelect: "",
      objWorkSelect: [],
      objWorks: [],
      dates: [],
      normalDate: [],
      reportData: [],
      totalReportData: [],
      exelData: [],
      url: "https://citystroi.bitrix24.ru/rest/73/gjdt5g3y10jxw3r9/",
    };
  },
  methods: {
    //TODO сделать функцию выгрузки в xls
    async exportXls() {
      try {
        const workbook = new exeljs.Workbook();
        workbook.views = [
          {
            x: 0,
            y: 500,
            width: 29040,
            height: 15840,
            visibility: "visible",
          },
        ];
        const worksheet = workbook.addWorksheet("Отчет по материалам");
        worksheet.columns = [
          {
            header: "Дата",
            key: "date",
            width: 12,
            style: { numFmt: "dd/mm/yyyy" },
          },
          { header: "Объект", key: "obj", width: 25 },
          { header: "Вид работ", key: "objWork", width: 19 },
          { header: "Единица измерения", key: "materialUnit", width: 17 },
          { header: "Вид материала", key: "material", width: 19 },
          {
            header: "План",
            key: "materialPlan",
            width: 12,
            style: { numFmt: 0 },
          },
          {
            header: "Факт",
            key: "materialQuantity",
            width: 12,
            style: { numFmt: 0 },
          },
          {
            header: "Разница",
            key: "materialDiff",
            width: 12,
            style: { numFmt: 0 },
          },
          { header: "Единица измерения", key: "techUnit", width: 17 },
          { header: "Вид техники", key: "tech", width: 19 },
          { header: "Что делала техника", key: "techText", width: 30 },
          { header: "План", key: "techPlan", width: 12, style: { numFmt: 0 } },
          {
            header: "Факт",
            key: "techQuantity",
            width: 12,
            style: { numFmt: 0 },
          },
          {
            header: "Разница",
            key: "techDiff",
            width: 12,
            style: { numFmt: 0 },
          },
          { header: "Единица измерения", key: "workersUnit", width: 17 },
          {
            header: "План",
            key: "workersPlan",
            width: 12,
            style: { numFmt: 0 },
          },
          {
            header: "Факт",
            key: "workersQuantity",
            width: 12,
            style: { numFmt: 0 },
          },
          {
            header: "Разница",
            key: "workersDiff",
            width: 12,
            style: { numFmt: 0 },
          },
        ];

        for (const item of this.reportData) {
          const row = worksheet.addRow(item);
          row.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        }
        const totalHeader = worksheet.addRow({
          date: "ИТОГО: ",
        });
        totalHeader.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
        for (const totalItem of this.totalReportData) {
          const total = worksheet.addRow(totalItem);
          total.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        }

        worksheet.getColumn(1).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "ff9800" },
        };
        worksheet.getColumn(2).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "ff9800" },
        };
        worksheet.getColumn(3).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "9e9e9e" },
        };
        worksheet.getColumn(4).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "03a9f4" },
        };
        worksheet.getColumn(5).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "03a9f4" },
        };
        worksheet.getColumn(6).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "03a9f4" },
        };
        worksheet.getColumn(7).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "03a9f4" },
        };
        worksheet.getColumn(8).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "03a9f4" },
        };
        worksheet.getColumn(9).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "8bc34a" },
        };
        worksheet.getColumn(10).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "8bc34a" },
        };
        worksheet.getColumn(11).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "8bc34a" },
        };
        worksheet.getColumn(12).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "8bc34a" },
        };
        worksheet.getColumn(13).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "8bc34a" },
        };
        worksheet.getColumn(14).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "8bc34a" },
        };
        worksheet.getColumn(15).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "ffeb3b" },
        };
        worksheet.getColumn(16).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "ffeb3b" },
        };
        worksheet.getColumn(17).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "ffeb3b" },
        };
        worksheet.getColumn(18).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "ffeb3b" },
        };

        const buffer = await workbook.xlsx.writeBuffer();
        const fileType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const blob = new Blob([buffer], { type: fileType });
        fileWrite(blob, "report.xlsx");
      } catch (e) {
        console.log(e);
      }
    },
    pause(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    async getObj() {
      try {
        this.obj = [];
        const params = {
          IBLOCK_TYPE_ID: "lists",
          IBLOCK_ID: "97",
        };
        const method = "lists.element.get";
        let i = 1;
        let next = 0;
        while (i > 0) {
          params.start = next;
          const objData = await axios.post(this.url + method, params);
          next = objData.data.next;
          for (const elem of objData.data.result) {
            this.obj.push(elem);
          }
          if (!next) {
            i = 0;
          }
        }
        //console.log(this.obj)
        this.obj.sort((a, b) => {
          if (a["NAME"] < b["NAME"]) {
            return -1;
          }
          if (a["NAME"] > b["NAME"]) {
            return 1;
          }
          // a должно быть равным b
          return 0;
        });
      } catch (e) {
        console.log(e);
      }
    },
    async getStatObj() {
      try {
        console.log("getStatObj");
        try {
          this.objWorks = [];
          const params = {
            IBLOCK_TYPE_ID: "lists",
            IBLOCK_ID: "97",
            ELEMENT_ID: this.objSelect,
            //auth: this.auth.ACCESS_TOKEN,
          };
          const method = "lists.element.get";
          const objData = await axios.post(this.url + method, params);
          console.log({ objData });
          const statObjData = Object.values(
            objData.data.result[0].PROPERTY_1353
          )[0];
          for (const stat of statObjData.split(";")) {
            let pushStat = stat.replace(/[^a-zа-яё0-9\s]/gi, "");
            pushStat = pushStat.trim();
            if (pushStat != " " || pushStat != "") this.objWorks.push(pushStat);
          }

          this.objWorks.sort((a, b) => {
            if (a["NAME"] < b["NAME"]) {
              return -1;
            }
            if (a["NAME"] > b["NAME"]) {
              return 1;
            }
            // a должно быть равным b
            return 0;
          });
        } catch (e) {
          console.log(e);
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getReport() {
      try {
        this.loading = true;
        this.reportData = [];
        this.totalReportData = [];
        this.normalDate = [];
        await this.normalizeDate();
        const params = {
          IBLOCK_TYPE_ID: "lists",
          IBLOCK_ID: "153",
          FILTER: {
            ">=PROPERTY_1409": this.normalDate[0],
            "<=PROPERTY_1409": this.normalDate[1],
          },
        };
        if (this.objSelect) params["FILTER"]["PROPERTY_1411"] = this.objSelect;
        if (this.objWorkSelect)
          params["FILTER"]["PROPERTY_1413"] = this.objWorkSelect;
        const method = "lists.element.get";
        let i = 1;
        let next = 0;
        console.log({ params });

        while (i > 0) {
          params.start = next;
          console.log(params);
          const reportData = await axios.post(this.url + method, params);
          console.log(reportData);
          next = reportData.data.next;
          for (const elem of reportData.data.result) {
            const index = this.obj.findIndex(
              (e) => e.ID == Object.values(elem["PROPERTY_1411"])[0]
            );
            console.log({ index });
            console.log(this.obj[index]);
            const item = {
              id: elem["ID"],
              date: elem["PROPERTY_1409"]
                ? Object.values(elem["PROPERTY_1409"])[0]
                : "", //дата
              obj: this.obj[index].NAME, //объект
              objWork: elem["PROPERTY_1413"]
                ? Object.values(elem["PROPERTY_1413"])[0]
                : "", //вид работ
              materialUnit: elem["PROPERTY_1425"]
                ? Object.values(elem["PROPERTY_1425"])[0]
                : "", //материал единиц
              material: elem["PROPERTY_1445"]
                ? Object.values(elem["PROPERTY_1445"])[0]
                : "", //материал
              materialPlan: elem["PROPERTY_1419"]
                ? Number(Object.values(elem["PROPERTY_1419"])[0])
                : "", //материал план
              materialQuantity: elem["PROPERTY_1421"]
                ? Number(Object.values(elem["PROPERTY_1421"])[0])
                : "", //материал кол-во
              materialDiff: elem["PROPERTY_1423"]
                ? Number(Object.values(elem["PROPERTY_1423"])[0])
                : "", //материал разница
              tech: elem["PROPERTY_1427"]
                ? Object.values(elem["PROPERTY_1427"])[0]
                : "", //техника
              techText: elem["DETAIL_TEXT"], //техника подробнее
              techPlan: elem["PROPERTY_1429"]
                ? Number(Object.values(elem["PROPERTY_1429"])[0])
                : "", //техника план
              techQuantity: elem["PROPERTY_1431"]
                ? Number(Object.values(elem["PROPERTY_1431"])[0])
                : "", //техника кол-во
              techDiff: elem["PROPERTY_1433"]
                ? Number(Object.values(elem["PROPERTY_1433"])[0])
                : "", //техника разница
              techUnit: elem["PROPERTY_1435"]
                ? Object.values(elem["PROPERTY_1435"])[0]
                : "", //техника единиц
              workersUnit: elem["PROPERTY_1447"]
                ? Object.values(elem["PROPERTY_1447"])[0]
                : "", //рабочие единиц
              workersPlan: elem["PROPERTY_1437"]
                ? Number(Object.values(elem["PROPERTY_1437"])[0])
                : "", //рабочие план
              workersQuantity: elem["PROPERTY_1439"]
                ? Number(Object.values(elem["PROPERTY_1439"])[0])
                : "", //рабочие кол-во
              workersDiff: elem["PROPERTY_1451"]
                ? Number(Object.values(elem["PROPERTY_1451"])[0])
                : "", //рабочие разница
            };
            this.reportData.push(item);
          }
          if (!next) {
            i = 0;
          }
        }
        console.log(this.reportData, "reportData");
        this.formatReport();
        this.loading = false;
      } catch (e) {
        this.loading = false;
        console.log(e);
      }
    },
    formatReport() {
      const totalReportData = [];
      const report = this.reportData.map((e) => e);
      for (const item of report) {
        const elem = {
          id: item.id,
          date: "", //item.id, //дата
          obj: item.obj, //объект
          objWork: item.objWork, //вид работ
          materialUnit: item.materialUnit, //материал единиц
          material: item.material, //материал
          materialPlan: Number(item.materialPlan), //материал план
          materialQuantity: Number(item.materialQuantity), //материал кол-во
          materialDiff: Number(item.materialDiff), //материал разница
          tech: item.tech, //техника
          techText: "", //техника подробнее
          techPlan: Number(item.techPlan), //техника план
          techQuantity: Number(item.techQuantity), //техника кол-во
          techDiff: Number(item.techDiff), //техника разница
          techUnit: item.techUnit, //техника единиц
          workersUnit: item.workersUnit, //рабочие единиц
          workersPlan: Number(item.workersPlan), //рабочие план
          workersQuantity: Number(item.workersQuantity), //рабочие кол-во
          workersDiff: Number(item.workersDiff), //рабочие разница
        };
        const index = totalReportData.findIndex((e) => e.obj == elem.obj);
        console.log({ index });
        if (index < 0) {
          totalReportData.push({
            obj: elem.obj,
            works: [
              {
                title: elem.objWork,
                workersUnit: elem.workersUnit, //рабочие единиц
                workersPlan: elem.workersPlan, //рабочие план
                workersQuantity: elem.workersQuantity, //рабочие кол-во
                workersDiff: elem.workersDiff, //рабочие разница
                material: [
                  {
                    title: elem.material,
                    materialUnit: elem.materialUnit, //материал единиц
                    materialPlan: elem.materialPlan, //материал план
                    materialQuantity: elem.materialQuantity, //материал кол-во
                    materialDiff: elem.materialDiff, //материал разница
                  },
                ],
                tech: [
                  {
                    title: elem.tech, //техника
                    techText: "", //техника подробнее
                    techPlan: elem.techPlan, //техника план
                    techQuantity: elem.techQuantity, //техника кол-во
                    techDiff: elem.techDiff, //техника разница
                    techUnit: elem.techUnit, //техника единиц
                  },
                ],
              },
            ],
          });
        } else {
          const indexWorks = totalReportData[index].works.findIndex(
            (e) => e.title == elem.objWork
          );
          if (indexWorks < 0) {
            totalReportData[index].works.push({
              title: elem.objWork,
              workersUnit: elem.workersUnit, //рабочие единиц
              workersPlan: elem.workersPlan, //рабочие план
              workersQuantity: elem.workersQuantity, //рабочие кол-во
              workersDiff: elem.workersDiff, //рабочие разница
              material: [
                {
                  title: elem.material,
                  materialUnit: elem.materialUnit, //материал единиц
                  materialPlan: elem.materialPlan, //материал план
                  materialQuantity: elem.materialQuantity, //материал кол-во
                  materialDiff: elem.materialDiff, //материал разница
                },
              ],
              tech: [
                {
                  title: elem.tech, //техника
                  techText: "", //техника подробнее
                  techPlan: elem.techPlan, //техника план
                  techQuantity: elem.techQuantity, //техника кол-во
                  techDiff: elem.techDiff, //техника разница
                  techUnit: elem.techUnit, //техника единиц
                },
              ],
            });
          } else {
            totalReportData[index].works[indexWorks].workersQuantity += Number(
              elem.workersQuantity
            );
            totalReportData[index].works[indexWorks].workersDiff =
              Number(totalReportData[index].works[indexWorks].workersPlan) -
              Number(totalReportData[index].works[indexWorks].workersQuantity);

            const indexMaterial = totalReportData[index].works[
              indexWorks
            ].material.findIndex((e) => e.title == elem.material);
            if (indexMaterial < 0) {
              totalReportData[index].works[indexWorks].material.push({
                title: elem.material,
                materialUnit: elem.materialUnit, //материал единиц
                materialPlan: elem.materialPlan, //материал план
                materialQuantity: elem.materialQuantity, //материал кол-во
                materialDiff: elem.materialDiff, //материал разница
              });
            } else {
              totalReportData[index].works[indexWorks].material[
                indexMaterial
              ].materialQuantity += Number(elem.materialQuantity);
              totalReportData[index].works[indexWorks].material[
                indexMaterial
              ].materialDiff =
                Number(
                  totalReportData[index].works[indexWorks].material[
                    indexMaterial
                  ].materialPlan
                ) -
                Number(
                  totalReportData[index].works[indexWorks].material[
                    indexMaterial
                  ].materialQuantity
                );
            }

            const indexTech = totalReportData[index].works[
              indexWorks
            ].tech.findIndex((e) => e.title == elem.tech);
            if (indexTech < 0) {
              totalReportData[index].works[indexWorks].tech.push({
                title: elem.tech, //техника
                techText: "", //техника подробнее
                techPlan: elem.techPlan, //техника план
                techQuantity: elem.techQuantity, //техника кол-во
                techDiff: elem.techDiff, //техника разница
                techUnit: elem.techUnit, //техника единиц
              });
            } else {
              totalReportData[index].works[indexWorks].tech[
                indexTech
              ].techQuantity += Number(elem.techQuantity);
              totalReportData[index].works[indexWorks].tech[
                indexTech
              ].techDiff =
                Number(
                  totalReportData[index].works[indexWorks].tech[indexTech]
                    .techPlan
                ) -
                Number(
                  totalReportData[index].works[indexWorks].tech[indexTech]
                    .techQuantity
                );
            }
          }
        }
      }
      for (const el of totalReportData) {
        for (const elWork of el.works) {
          console.log({ elWork });
          const row = {
            obj: el.obj,
            objWork: elWork.title,
            workersUnit: elWork.workersUnit, //рабочие единиц
            workersPlan: elWork.workersPlan, //рабочие план
            workersQuantity: elWork.workersQuantity, //рабочие кол-во
            workersDiff: elWork.workersDiff, //рабочие разница
            material: elWork.material[0].title,
            materialUnit: elWork.material[0].materialUnit, //материал единиц
            materialPlan: elWork.material[0].materialPlan, //материал план
            materialQuantity: elWork.material[0].materialQuantity, //материал кол-во
            materialDiff: elWork.material[0].materialDiff, //материал разница
            tech: "", //техника
            techText: "", //техника подробнее
            techPlan: "", //техника план
            techQuantity: "", //техника кол-во
            techDiff: "", //техника разница
            techUnit: "", //техника единиц
          };
          this.totalReportData.push(row);
          for (const materialWorkIndex in elWork.material) {
            if (materialWorkIndex != 0) {
              if (elWork.material[materialWorkIndex].materialQuantity > 0) {
                const materialRow = {
                  obj: el.obj,
                  objWork: elWork.title,
                  workersUnit: elWork.workersUnit, //рабочие единиц
                  workersPlan: elWork.workersPlan, //рабочие план
                  workersQuantity: elWork.workersQuantity, //рабочие кол-во
                  workersDiff: elWork.workersDiff, //рабочие разница
                  material: elWork.material[materialWorkIndex].title,
                  materialUnit: elWork.material[materialWorkIndex].materialUnit, //материал единиц
                  materialPlan: elWork.material[materialWorkIndex].materialPlan, //материал план
                  materialQuantity:
                    elWork.material[materialWorkIndex].materialQuantity, //материал кол-во
                  materialDiff: elWork.material[materialWorkIndex].materialDiff, //материал разница
                  tech: "", //техника
                  techText: "", //техника подробнее
                  techPlan: "", //техника план
                  techQuantity: "", //техника кол-во
                  techDiff: "", //техника разница
                  techUnit: "", //техника единиц
                };
                this.totalReportData.push(materialRow);
              }
            }
          }

          for (const techWorkIndex in elWork.tech) {
            // if (techWorkIndex != 0) {
            if (elWork.tech[techWorkIndex].techQuantity > 0) {
              const materialRow = {
                obj: el.obj,
                objWork: elWork.title,
                workersUnit: elWork.workersUnit, //рабочие единиц
                workersPlan: elWork.workersPlan, //рабочие план
                workersQuantity: elWork.workersQuantity, //рабочие кол-во
                workersDiff: elWork.workersDiff, //рабочие разница
                material: "",
                materialUnit: "", //материал единиц
                materialPlan: "", //материал план
                materialQuantity: "", //материал кол-во
                materialDiff: "", //материал разница
                tech: elWork.tech[techWorkIndex].title, //техника
                techText: elWork.tech[techWorkIndex].techText, //техника подробнее
                techPlan: elWork.tech[techWorkIndex].techPlan, //техника план
                techQuantity: elWork.tech[techWorkIndex].techQuantity, //техника кол-во
                techDiff: elWork.tech[techWorkIndex].techDiff, //техника разница
                techUnit: elWork.tech[techWorkIndex].techUnit, //техника единиц
              };
              this.totalReportData.push(materialRow);
            }
          }
        }
      }
    },
    async normalizeDate() {
      try {
        const nowDate = new Date();
        const year = nowDate.getFullYear();

        const firstDate =
          this.dates.length > 0 ? this.dates[0].split("-") : [year, "01", "01"];
        const twoDate =
          this.dates.length > 0 ? this.dates[1].split("-") : [year, "12", "01"];
        const firstDateFormated =
          firstDate[2] + "." + firstDate[1] + "." + firstDate[0] + " 00:00:00";
        const twoDateFormated =
          twoDate[2] + "." + twoDate[1] + "." + twoDate[0] + " 23:59:59";
        this.normalDate.push(firstDateFormated);
        this.normalDate.push(twoDateFormated);
      } catch (e) {
        console.log(e);
      }
    },
  },
  watch: {
    async objSelect(newObj, oldObj) {
      if (newObj !== oldObj) {
        await this.getStatObj();
      }
    },
  },
  mounted() {
    this.getObj();
  },
};
</script>
<style scoped>
.tech {
  zoom: 60%;
}
</style>
